const featureConfig = {
  "4HJl3JYH5TzUeylFEHKj": {
    points: false,
    bookings: true,
    profile: true,
  },
  iNANAwfMb6EXNtp7MRwJ: {
    points: true,
    bookings: true,
    profile: true,
  },
};

export default featureConfig;
